@if (shouldShowPassStrip) {
    <div (click)="onStripClick()" class="product-pass-band center">
        <div class="product-pass-band-sections">
            <b class="product-pass-band-price"> &#8377; {{ passPrice }} </b>
            with
            <img [src]="deployUrl + '/assets/images/pass_logo.png'" alt="eatclub pass" width="35" />
            membership
            <img [src]="deployUrl + '/assets/images/pass-info.svg'" alt="pass info" width="15" />
        </div>
    </div>
}
